<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">Chi tiết vai trò</h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="120px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Đơn vị" prop="deptId">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.deptId"
                placeholder="Đơn vị"
                size="medium"
                filterable
                clearable
                @change="deptIdChanged"
              >
                <el-option
                  v-for="item in departments"
                  :key="item.id"
                  :label="`${item.deptName} - ${item.identityCode} (${item.parentName})`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="isCxlCaNhan">
            <el-form-item label="Vai trò" prop="roleId">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.roleId"
                placeholder="Vai trò"
                size="medium"
                filterable
                clearable
                @change="roleIdChanged"
              >
                <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="isCxlCaNhan">
            <el-form-item label="User" prop="userId">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.userId"
                placeholder="User"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in users"
                  :key="item.id"
                  :label="buildUsersLabel(item)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="5" v-if="isOutgoingFlow && checkPermission">
            <el-form-item label="Loại ký" prop="signIntrustCA">
              <el-checkbox :border="false" v-model="form.signIntrustCA" class="style-fullWidth">Intrust CA</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="5" v-if="isOutgoingFlow && checkPermission">
            <el-form-item prop="signToken">
              <el-checkbox :border="false" v-model="form.signToken" class="style-fullWidth">Ký token </el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="5" v-if="isOutgoingFlow && checkPermission">
            <el-form-item prop="signSmartCA">
              <el-checkbox :border="false" v-model="form.signSmartCA" class="style-fullWidth">Smart CA</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="5" v-if="isOutgoingFlow && checkPermission">
            <el-form-item prop="signType">
              <el-checkbox :border="false" v-model="form.signType" class="style-fullWidth">Ký sim CA</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="5" v-if="isOutgoingFlow && checkPermission">
            <el-form-item prop="signUSBToken">
              <el-checkbox :border="false" v-model="form.signUSBToken" class="style-fullWidth">Ký USB Token</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Hoạt động" prop="status">
              <el-checkbox
                :border="false"
                v-model="form.status"
                class="style-fullWidth"
              >
              </el-checkbox>
            </el-form-item>
          </el-col>


        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import constants from "../../../constants";
import departmentService from "../../../services/departmentService";
import h from "../../../services/h";
import roleService from "../../../services/roleService";
import userService from "../../../services/userService";
import utils from "../../../services/utils";
import CustomDialog from "../../common/custom-dialog";

export default {
  name: "vb-step-info-detail-dialog",
  components: { CustomDialog },
  props: ["isOpen", "vbStepInfoForm", "stepType", "isOutgoingFlow"],
  data() {
    return {
      form: {
        deptId: null,
        roleId: null,
        userId: null,
        status: null,
        signType: false,
        signSmartCA: false,
        signIntrustCA: false,
        signToken: false,
        signUSBToken: false,
      },
      rules: {
        deptId: null,
        roleId: null,
        userId: null,
        status: null,
      },
      departments: [],
      roles: [],
      users: [],
      isSearchingUsers: false,
      // checkPermission: false,
      checkPermission: true,
    };
  },

  computed: {
    isCxlCaNhan() {
      return this.stepType === constants.STEP.STEP_TYPE.CANHAN;
    },
    isCxlDonVi() {
      return this.stepType === constants.STEP.STEP_TYPE.DONVI;
    },
  },

  async created() {
    await this.loadRoles();
    this.initComponent();
    await this.loadUsers();
    await this.loadDepartments();
  },

  methods: {
    deptIdChanged() {
      this.form.userId = null;
      this.loadUsers();
    },

    roleIdChanged(value) {
      // if (value && value.length === 1) {
      //   let currentRole = this.roles.find((item) => item.id === value[0]);
      //   if (currentRole.roleCode === constants.ROLE.CODE.LANH_DAO) {
      //     this.checkPermission = true;
      //   } else {
      //     this.checkPermission = false;
      //   }
      // } else {
      //   this.checkPermission = false;
      // }

      // todo hiển thị tất cả loại kí
      this.checkPermission = true;
      this.form.userId = null;
      this.loadUsers();
    },

    bindDataToForm() {
      this.form.deptId = this.vbStepInfoForm.deptId;
      this.form.roleId = this.vbStepInfoForm.roleId;
      this.form.userId = this.vbStepInfoForm.userId;
      this.form.signType = this.vbStepInfoForm.signType;
      this.form.signSmartCA = this.vbStepInfoForm.signSmartCA;
      this.form.signIntrustCA = this.vbStepInfoForm.signIntrustCA;
      this.form.signToken = this.vbStepInfoForm.signToken;
      this.form.signUSBToken = this.vbStepInfoForm.signUSBToken;
      let currentRole = this.roles.find((item) => item.id === this.form.roleId);
      if (currentRole && currentRole.roleCode === constants.ROLE.CODE.LANH_DAO) {
        this.checkPermission = true;
      }
      this.form.status =
        this.vbStepInfoForm.status === constants.STATUS_.ACTIVE;
    },

    loadUsers() {
      return (this.form.deptId
        ? userService
            .findall({
              deptIds: this.form.deptId ? [this.form.deptId] : null,
              roleIds: this.form.roleId ? [this.form.roleId] : null,
              status: constants.STATUS_.ACTIVE,
              includedIds: this.form.userId ? [this.form.userId] : null,
            })
            .then((response) => response.data)
        : Promise.resolve([])
      ).then((users) => {
        this.users = users;
      });
    },

    loadDepartments() {
      return departmentService
        .findAll2({ status: constants.STATUS_.ACTIVE }, { sort: "path,asc" })
        .then((response) => (this.departments = response.data));
    },

    loadRoles() {
      return roleService
        .findAll(
          {
            roleCodes: [
              constants.ROLE.CODE.LANH_DAO,
              constants.ROLE.CODE.CHUYEN_VIEN,
              constants.ROLE.CODE.VAN_THU,
            ],
          },
          { sort: "roleName,asc" }
        )
        .then((response) => (this.roles = response.data));
    },

    buildUsersLabel(user) {
      return `${user.fullName} (${user.userName})`;
    },

    /**
     * populate thêm các thông tin tên để hiển thị;
     * @param vbStepInfoForm
     */
    async populateExtendData(vbStepInfoForm) {
      vbStepInfoForm.fullName = this.getFullName(vbStepInfoForm.userId);
      vbStepInfoForm.roleName = this.getRoleName(vbStepInfoForm.roleId);
      vbStepInfoForm.deptName = this.getDeptName(vbStepInfoForm.deptId);
    },

    getFullName(userId) {
      if (!userId) return "-";
      let user = h.find(this.users, (user) => user.id === userId);
      return user ? user.fullName : "-";
    },

    getRoleName(roleId) {
      if (!roleId) return "-";
      let role = h.find(this.roles, (role) => role.id === roleId);
      return role ? role.roleName : "-";
    },

    getDeptName(deptId) {
      if (!deptId) return "-";
      let department = h.find(
        this.departments,
        (department) => department.id === deptId
      );
      return department ? department.deptName : "-";
    },

    async convertToSubmitForm() {
      let vbStepInfoForm = {
        deptId: this.form.deptId,
        roleId: this.form.roleId,
        userId: this.form.userId,
        status: this.form.status
          ? constants.STATUS_.ACTIVE
          : constants.STATUS_.DEACTIVE,
        signType: this.form.signType,
        signSmartCA: this.form.signSmartCA,
        signIntrustCA: this.form.signIntrustCA,
        signToken: this.form.signToken,
        signUSBToken: this.form.signUSBToken,
      };
      await this.populateExtendData(vbStepInfoForm);
      return Promise.resolve(vbStepInfoForm);
    },

    submit() {
      return this.validateForm()
        .then(() => this.convertToSubmitForm())
        .then((form) => {
          this.$emit("submit", { form });
        });
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    initValidationRules() {
      let defaultRequiredConstrains = utils.buildRequiredValidationConstrains();
      this.rules.deptId = [defaultRequiredConstrains];
    },

    initComponent() {
      this.initValidationRules();
      this.bindDataToForm();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/setting/cau-hinh-luong-v2/vb-step-info-detail-dialog.vue